module.exports = __webpack_public_path__ + "media/stylesheets/images/martech/icon_lpo01-b9c8bd416e13addf0c61ea9970abd19e.svg";